;(function () {
  'use strict'

  angular.module('contrast.tags').constant('TAGGING_LABEL', '(Create tag)')
})()
